import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const printerProofService = {
    getAllPrinterProofs, 
    updatePrinterProofStatus,
    getPrinterProof,
    updatePrinterProof,
    createPrinterProof,
  };

const MODULE = {
  PRINTER: 'rnd-printer-proof-statuses',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'PrinterProof') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export async function getAllPrinterProofs(filter) {
   
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        name: filter.name,
        is_active: filter.isActive
      }
    }

    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
    
    return await apiHelper(API_URL).get(`/${MODULE.PRINTER}`, requestOptions)
}


export function updatePrinterProofStatus(data) {
  const requestOptions = {
    is_active: data.isActive
  }

  return apiHelper(API_URL).patch(`/${MODULE.PRINTER}/${data.id}`, requestOptions)
}

export async function getPrinterProof(id) {
  return await apiHelper(API_URL).get(`/${MODULE.PRINTER}/${id}`)
}

export function updatePrinterProof(data) {
  const requestOptions = {
    name: data.name,
    is_active: data.isActive,
  }

  return apiHelper(API_URL).put(`/${MODULE.PRINTER}/${data.id}`, requestOptions)
}

export function createPrinterProof(data) {
  const requestOptions = {
    name: data.name,
  }
  return apiHelper(API_URL).post(`/${MODULE.PRINTER}`, requestOptions)
}